"use client";

import Link from "next/link";
import type { ComponentProps } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { localizePublicPathname } from "@/lib/i18n/public-routing";
import { type SupportedLanguage } from "@/lib/languages";

type PublicLinkProps = ComponentProps<typeof Link>;

function localizeHref(
  href: PublicLinkProps["href"],
  locale: SupportedLanguage
): PublicLinkProps["href"] {
  if (typeof href === "string") {
    return localizePublicPathname(href, locale);
  }

  if (href && typeof href === "object" && typeof href.pathname === "string") {
    return {
      ...href,
      pathname: localizePublicPathname(href.pathname, locale),
    };
  }

  return href;
}

export function PublicLink({ href, ...props }: PublicLinkProps) {
  const { language } = useLanguage();

  return <Link href={localizeHref(href, language)} {...props} />;
}
